define.alias("shared/utils/object-methods/object-camel-to-snake", "settings/utils/object-methods/object-camel-to-snake");